import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { RootStates } from "redux/store";
import { apiUrl } from "../../constants/paths";

export const teamsApi = createApi({
  reducerPath: "teamsApi",
  baseQuery: fetchBaseQuery({
    baseUrl: process.env.REACT_APP_API_BASE_URL,
    prepareHeaders: (headers, { getState }) => {
      const token = (getState() as RootStates).auth.token;
      if (token) {
        headers.set("authorization", `Bearer ${token}`);
      }
      return headers;
    },
  }),
  endpoints: (build) => ({
    sendInvite: build.mutation({
      query: (body) => ({
        url: apiUrl.sendInvite,
        method: "POST",
        body: body.values,
      }),
    }),
    getTeamByProjectId: build.mutation({
      query: (body) => ({
        url: apiUrl.project + `/${body.projectId}/team`,
        method: "GET",
      }),
    }),
    getAllMembers: build.mutation({
      query: (params) => ({
        url: apiUrl.users + `?limit=${params.limit}`,
        method: "GET",
      }),
    }),
    deleteTeam: build.mutation({
      query: (body) => ({
        url: apiUrl.project + `/${body.projectId}/team`,
        method: "DELETE",
        body: body.values,
      }),
    }),
  }),
});

export const {
  useGetTeamByProjectIdMutation,
  useGetAllMembersMutation,
  useSendInviteMutation,
  useDeleteTeamMutation,
} = teamsApi;
